import React, { FC } from 'react';
import { LightHeader } from '../../../header/light/LightHeader';

export const SignUpLayout: FC = ({ children }) => (
  <>
    <LightHeader source="nav-signup" />
    <div className="content">{children}</div>
  </>
);
